<script setup lang="ts">
import {MultiSelect} from "@progress/kendo-vue-dropdowns";
import {useUxData} from "@/stores/ux-data";
import {computed} from "vue";

const emit = defineEmits(['categorySelected'])
const props = defineProps<{
  placeholder: string | undefined,
  // Optional controlled selection (array of type aliases). Omitted → uncontrolled.
  selected?: string[],
}>()

const ux = useUxData();

const dataItems = computed(() => {
  const typeOptions = (Object.getOwnPropertyNames(ux.labels.swade.data.edges.types) ?? []).map((value: string) => {
    return {
      label: ux.labels.swade.data.edges.types[value ?? ''] ?? '',
      alias: value
    }
  })

  typeOptions.splice(1, 0, {
    label: "All Other Types",
    alias: "custom",
  });

  return typeOptions;
});

const valueBinding = computed(() =>
  props.selected === undefined
    ? {}
    : { value: dataItems.value.filter((item) => props.selected!.includes(item.alias)) }
)

const onChange = (event: any) => {
  emit('categorySelected', event);
}
</script>

<template>
  <MultiSelect
      text-field="label"
      data-item-key="alias"
      class="text-center p-0"
      :placeholder="placeholder"
      :data-items="dataItems"
      v-bind="valueBinding"
      @change="onChange($event)"
  />
</template>
